import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigPSIM } from 'app/models/configpsim.model';
import { AbStepConfigPSim } from 'app/abstract/full-pages/config-psim/step-config-psim.abstract';

@Injectable({
    providedIn: 'root'
})
export class StepConfigpsimService extends AbStepConfigPSim {

    public qtdFinalizadas: number = 1;
    public mostrarConfgGerais: boolean = false;
    public configPsim = new ConfigPSIM();

    public getResultadoCompleted(): number {
        return this.qtdFinalizadas;
    }

    observableCompleted(): Observable<boolean> {
        return new Observable((observer) => {
            setTimeout(() => {
                observer.next(true);
                observer.complete();
            }, 100);
        })
    }

    public setResultadoCompleted(): Observable<any> {
        this.qtdFinalizadas = this.qtdFinalizadas + 1;
        return this.observableCompleted();
    }

    public setVoltarResultadoCompleted(): Observable<any> {
        this.qtdFinalizadas = this.qtdFinalizadas - 1;
        return this.observableCompleted();
    }

    public reiniciarContagem() {
        this.qtdFinalizadas = 1;
    }

    public terminarContagem() {
        this.qtdFinalizadas = 8;
    }

    public prepararConfigPsim(configPSIM: ConfigPSIM) {
        configPSIM.latitude = this.configPsim.latitude;
        configPSIM.longitude = this.configPsim.longitude;
        configPSIM.servidor = this.configPsim.servidor;
        configPSIM.porta = this.configPsim.porta;
        configPSIM.habilitarPalavraChaveSenhaCoacao = this.configPsim.habilitarPalavraChaveSenhaCoacao;
        configPSIM.senhaCoacaoObrigatoria = this.configPsim.senhaCoacaoObrigatoria;
        configPSIM.palavraChaveObrigatoria = this.configPsim.palavraChaveObrigatoria;
        configPSIM.habilitarCadastroUsuarioPessoa = this.configPsim.habilitarCadastroUsuarioPessoa;
    }
}


